// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1W-84","errorLogs":"EditorFooter_errorLogs__1hn2_"};